import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {steps, summaryReasons, saveToHistory, setStep} from '../IdfNewPlanSignupSlice';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import BtnWhiteBlackBorderSmallSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import {prepareNewWindowUrl} from 'app/utilities/StringHelpers/StringHelpers';
import {isMobile} from 'react-device-detect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {
  createReportIdfNewPlanSignupGeneralError, createReportIdfNewPlanSignupOrderSummaryPageButtonClicked,
  createReportIdfNewPlanSignupOrderSummaryPageDisplayed
} from 'app/utilities/reports/createReport';

const SummaryStep = (props) => {

  useEffect(() => {
    props.saveToHistory('summary');
  }, []);

  function SuccessContent() {
    createReportIdfNewPlanSignupOrderSummaryPageDisplayed(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup.nextBpKey,
      props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
    )
    return (
      <div className={'summary-content'}>
        <div className="title-container">
        <span className="title">
המנוי שויך בהצלחה לתכנית החדשה של צה״ל      </span>
          <span className="subTitle">
       השינוי בפועל יחל ממחזור החיוב הקרוב<br />
          (21 לחודש)
      </span>
        </div>
        <div className={'main-content'}>
          <div className={'headline-container'}>
            <span className={'headline'}>חיובים חודשיים</span>
          </div>
          <div className={'details'}>
            <div className={'detail-row-container'}>
              <div className={'details-title-row'}>
                <span className={'detail-title'}>תוכנית סלולר</span>
              </div>
              <div className={'detail-row'}>
              <span
                className={'detail-text'}>{props.idfNewPlanSignup.selectedPackage.packageObj?.benefitTitle?.value}</span>
                <span className={'detail-price'}>{props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value}</span>
              </div>
            </div>
            <div className={'price-summary-content-container'}>
              <div className={'price-summary-row'}>
                <div className={'price-summary-content'}>
                  <span className={'price-summary-text'}>סה”כ חיוב חודשי</span>
                  <span
                    className={'price-summary-price'}>{props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'bottom-content'}>
          <span className={'bottom-content-title'}>סיכום ההזמנה נשלח לדוא״ל</span>
          <span className={'bottom-content-text'}>{props.idfNewPlanSignup.confirmationStep.email}</span>
        </div>
        <div className={'button-container'}>
          <BtnSubmit
            onclick={() => {
              createReportIdfNewPlanSignupOrderSummaryPageButtonClicked(
                props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
                props.userData?.loginData.userDetails.contactNumber,
                props.userData?.loginData.userDetails.IDNumber,
                props.idfNewPlanSignup.nextBpKey,
                props.idfNewPlanSignup.selectedPackage.packageObj.price.value
              )
              EpiContext.navigateTo(Config.lobbyUrl);
            }}
            text={'סיום'}
          />
        </div>
      </div>
    );
  }

  function ErrorContent() {
    createReportIdfNewPlanSignupGeneralError(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber,
      props.idfNewPlanSignup?.selectedPackage?.packageObj?.packageId,
      props.idfNewPlanSignup?.selectedPackage?.packageObj?.price?.value
    )

    return (
      <div className={'error-content'}>
        <div className={'top-content'}>
          <Image src={require('../images/error.svg')} alt={'error'} />
          {
            isMobile ? (
                <><span className="summary-title">מצטערים, כרגע לא ניתן לבצע</span>
                  <span className="summary-title">את הפעולה שביקשת</span></>
              )
              :
              (
                <span className="summary-title">מצטערים, כרגע לא ניתן לבצע את הפעולה שביקשת</span>
              )
          }
        </div>
        <div className={'summary-body'}>
          {isMobile ? (
            <>
              <span>נציגנו ישמחו לסייע לך</span>
              <div className={'buttons'}>
                <BtnWhiteBlackBorderSmallSize
                  onclick={() => prepareNewWindowUrl(`tel:${Config.idfCellcomCenter}`)}
                  text={'חייגו 999* לנציג שירות'}
                />
                <BtnWhiteBlackBorderSmallSize
                  onclick={() => prepareNewWindowUrl(`tel:${Config.idfCellcomCenterFullNumber}`)}
                  text={'חייגו 052-9990777 לנציג שירות'}
                />
              </div>
            </>
          ) : (
            <>
              <span>נציגנו ישמחו לסייע לך</span>
              <span>חייגו 999* או 052-9990777 לנציג שירות</span>
            </>
          )}
        </div>
        <div
          className={'button-box'}>
          <BtnWhiteBlackBorderBigSize
            onclick={() => {
              EpiContext.navigateTo(Config.lobbyUrl);
            }}
            text={'חזרה לאיזור האישי'}
          />
        </div>

      </div>
    );
  }

  function renderContent() {
    switch (props.idfNewPlanSignup.summaryReason) {
      case summaryReasons.SUCCESS:
        return <SuccessContent />;
      default:
        return <ErrorContent />;
    }
  }

  return (
    renderContent()
  );
};

const mapStateToProps = (state) => {
  return {
    idfNewPlanSignup: state.idfNewPlanSignup,
    userData: state.authentication

  };
};

const mapDispatchToProps = {
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryStep);
